var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('div',_vm._b({staticClass:"slot"},'div',_vm.$attrs,false),_vm._l((_vm.items),function(item){return _c(_vm.Components[item.type],{key:item.source,tag:"component",attrs:{"value":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }